import * as images from "@/components/images/Images";
import { ServicePlanCardProps } from "@/components/screen/global-components/services/ServicePlanCard";
import { ROUTES } from "@/constants";

export const useCasePricingPlansCards: ServicePlanCardProps[] = [
  {
    title: "Standard",
    image: images.solar_buildings1,
    price: "<span>$0.10</span>&nbsp;per word",
    description:
      "Our most basic offering for straight forward academic translation projects that don’t require a certificate.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
  },
  {
    title: "Certified",
    image: images.solar_buildings2,
    price: "<span>$24.50</span>&nbsp;/ page",
    description:
      "This plan is for when you might require a certified or notarized academic translation to have your translation accepted for official purposes.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
  },
  {
    title: "Enterprise",
    image: images.solar_buildings3,
    price: "Pricing on request",
    description:
      "Custom-fit and fully managed translation services best for businesses with complex, unique, or recurring needs at any scale.",
    mainButton: "Get  a quote",
    mainButtonLink: ROUTES.getQuote,
    highlight: "accent",
  },
];
